import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { CustomDatePicker } from 'uikit/CustomDatePicker';
import './BalancesDocumentsFiltersBar.scss';

const BalancesDocumentsFiltersBar = ({ filters, handleSetFilters }) => {
  const i18n = useContext(i18nContext);
  const currentDate = new Date();

  return (
    <div className={'balances-documents-filters-wrapper'}>
      <div className={'balances-documents-date-range-filters-wrapper'}>
        <div>
          <span>{i18n.getMessage('balances.balancesDocuments.filter.date.label')}</span>
          <CustomDatePicker onChange={handleSetFilters} name={'date'} value={filters.date} maxDate={currentDate} />
        </div>
      </div>
    </div>
  );
};

BalancesDocumentsFiltersBar.propTypes = {
  filters: PropTypes.object,
  handleSetFilters: PropTypes.func
};

export default BalancesDocumentsFiltersBar;
